import { colors } from 'theme'

export const defaultThemeStyles = {
    background: colors.white
}
